import { render, staticRenderFns } from "./stpay.vue?vue&type=template&id=3a7a6338&scoped=true"
import script from "./stpay.vue?vue&type=script&lang=js"
export * from "./stpay.vue?vue&type=script&lang=js"
import style0 from "./stpay.vue?vue&type=style&index=0&id=3a7a6338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7a6338",
  null
  
)

export default component.exports